import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "item"]

  connect() {
    this.apply("all")
  }

  filter(event) {
    event.preventDefault()
    this.apply(event.params.author || "all")
  }

  apply(author) {
    this.buttonTargets.forEach((button) => {
      const isActive = button.dataset.blogFilterAuthorParam === author
      button.classList.toggle("is-active", isActive)
      button.setAttribute("aria-pressed", isActive ? "true" : "false")
    })

    this.itemTargets.forEach((item) => {
      item.hidden = author !== "all" && item.dataset.blogFilterAuthor !== author
    })
  }
}
